{
  "back": "Retour",
  "share": "Partager"
}
